<template>
	<div class="content">
		<transition name="fade" mode="out-in">
			<!-- your content here -->
			<router-view></router-view>
		</transition>
	</div>
</template>
<script>
	export default {};
</script>
<style lang="stylus">
	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.15s;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>
